import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { StoreLocatorService } from '../../../shared/services/store-locator.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { AnalyticsService } from '../../../shared/services/analytics.service';

@Component({
  selector: 'app-store-locator',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatLabel, MatSelect, MatOption, FormsModule, MatInputModule, MatOptionModule, RouterModule],
  templateUrl: './store-locator.component.html',
  styleUrl: './store-locator.component.scss'
})
export class StoreLocatorComponent implements OnInit, OnDestroy {
  environment: any = environment;
  searchText: string = '';
  foundText: boolean = false;
  serviceLocatorList: any[] = [];
  pageNo = 1;
  sub:Subscription=new Subscription()
  category!: string;
  categoryList:any = [];
  totalCount!: number;
  storeLocatorResponse: boolean = false;
  script:any;
  actualSchemaValue:any;
  constructor(private service: StoreLocatorService,
  private _renderer2: Renderer2,
  @Inject(DOCUMENT) private _document: Document,
  private schemaService: SchemaService, public utils: UtilsService, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService, private router: Router) {
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading();
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
    },
    error: (err: any) => {
      console.error('Error fetching meta data', err);
    }}));
    this.utils.showHeaderFooter.next(true);
  }

  ngOnInit(): void {
    this.getServiceLocator('new');
    this.sub.add( this.service.getCategories()
      .subscribe({
        next: (response: any) => {
          this.utils.hideLoading();
          if (response.success) {
            this.categoryList = response.categoryNames;
          }
        }
      }))
    this.callSchema();

  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = JSON.stringify(this.actualSchemaValue);
    this.script.defer = true;
    this._renderer2.appendChild(this._document.body, this.script);
  }
  getServiceLocator(type: string) {
    if (type == 'new') {
      this.serviceLocatorList = [];
      this.pageNo = 1;
    }
    this.utils.showLoading();
    this.sub.add(this.service.getStoreLocatorList({
      "serchArgs": this.searchText ? this.searchText : 'Delhi',
      "productCategory": this.category,
      "pageNo": this.pageNo++,
      "pageSize": 10
    }).subscribe((data) => {
      this.storeLocatorResponse = true;
      if (data.success) {
        this.foundText = this.searchText ? true : false;
        this.utils.hideLoading();
        if (data.storeLocatorListResponse.length) {
          this.serviceLocatorList = [...this.serviceLocatorList, ...data.storeLocatorListResponse];
          this.totalCount = data.totalCount;
        }
        else { this.pageNo--; }
      }
      else {
        this.utils.hideLoading();
        this.pageNo--;
        this.foundText = false;
      }
    }))
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }
}
